import { memo } from 'react';

import { Redirect } from 'expo-router';

import { routes } from 'navigation/routing';
import { LoyaltyProfile } from 'pages/loyalty/loyalty-profile/loyalty-profile';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLaunchDarklyClientReady } from 'state/launchdarkly/use-launch-darkly-client';

function ProfileTab() {
  const ldClientReady = useLaunchDarklyClientReady();
  const enableLoyaltyProfile = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_PROFILE);

  if (ldClientReady && !enableLoyaltyProfile) {
    return <Redirect href={routes.rewardsHistory} />;
  }

  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyProfile />
    </>
  );
}

export default memo(ProfileTab);
